import ContaPagarService from "@/services/ContaPagarService"
import moment from 'moment'
import store from '@/store'

export const actions = {
    async cadastrarContaPagar ({commit, dispatch}) {
        await commit('setShowInputAnexo', false)
        await commit('setContaPagar', {
            fornecedor_id: '',
            situacao: 'EM ABERTO',
            numero_documento: '',
            data_vencimento: moment().format('YYYY-MM-DD'),
            data_emissao: moment().format('YYYY-MM-DD'),
            data_pagamento: moment().format('YYYY-MM-DD'),
            valor: '',
            forma_pagamento: '',
            ocorrencia_tipo: '',
            ocorrencia: 'PARCELA ÚNICA',
            ocorrencia_quantidade: 1,
            numero_parcela: 1,
            ocorrencia_quantidade: '',
            numero_parcela: '',
            ocorrencia_quantidade: '',
            informacoes: '',
            anexo: '',
            grupo_id: '',
            portador_id: ''
        }),
        await commit('setShowInputAnexo', true)
        await dispatch('setModalCadastroContaPagar', true)

    },
    listarContaPagar: ({commit}, data) => {
        commit('setOverlay', true)
        ContaPagarService.listar(data)
        .then(res => {
            if(data.content == 'pdf'){
                commit('setModalPrint', res.data.pdf_link)
            }else{
                commit('setContasPagar', res.data)
            }
            
            commit('setOverlay', false)

        })
        .catch(e => {
            commit('setOverlay', false)
            console.log(e)
        })
    },

    baixarContaPagar: ({commit, dispatch}, data) => {
        dispatch('setModalBaixaContaPagar', false)
        commit('setOverlay', true)
        ContaPagarService.baixar(data.id)
        .then(res => {
            commit('setLancamentoBancario', {
                numero_documento: data.numero_documento,
                data_lancamento: data.data_pagamento,
                data_competencia: data.data_pagamento,
                historico: `Baixa conta a pagar Nº ${data.id}`,
                portador_id: data.portador_id,
                grupo_id: data.grupo_id,
                banco_id: data.banco_id,
                valor: data.valor,
                tipo: 'DÉBITO',
                contato_id: data.fornecedor_id
            })
            commit('setContaPagar', {...store.getters.getContaPagar, situacao: "PAGO"})
            dispatch('setModalCadastroLancamentoBancario', true);
            dispatch('listarContaPagar', {
                situacao: "EM ABERTO",
                limit: 20
            })
            commit('setOverlay', false)
            commit('snackbarSuccess', 'Conta baixada com sucesso.')
        })
        .catch(e => {
            commit('setOverlay', false)
            commit('snackbarError', 'Erro ao baixar conta.')
        })
    },
    visualizarContaPagar: ({commit, dispatch}, data) => {
        
        commit('setContaPagar', {...data})
        dispatch('setModalCadastroContaPagar', true)
    },
    
    salvarContaPagar: ({commit, dispatch}, data) => {
        commit('setOverlay', true)
        ContaPagarService.salvar(data)
        .then(res => {
            commit('setShowInputAnexo', false)
            commit('setContaPagar', res.data)
            dispatch('listarContaPagar', {
                situacao: "EM ABERTO",
                limit: 20
            })
            commit('setOverlay', false)
            commit('snackbarSuccess', 'Registro salvo.')
        })
        .then(() => {
            commit('setShowInputAnexo', true)
        })
        .catch(e => {
            if(e.response.status == 422){
                commit('alertError', e.response.data.errors)
            }
            console.log(e)
            commit('setOverlay', false)
            commit('snackbarError', 'Erro ao cadastrar.')
        })
    },
    atualizarContaPagar: ({commit, dispatch}, data) => {
        commit('setOverlay', true)
        ContaPagarService.atualizar(data)
        .then(res => {
            commit('setShowInputAnexo', false)
            dispatch('listarContaPagar', {limit: 20, situacao: 'EM ABERTO'})
            commit('setOverlay', false)
            commit('setContaPagar', res.data)
            commit('snackbarInfo', 'Registro atualizado.')
        })
        .then(() => {
            commit('setShowInputAnexo', true)
        })
        .catch(e => {
            // if(e.response.status == 422){
            //     commit('alertError', e.response.data.errors)
            // }
            console.log(e)
            commit('setOverlay', false)
            commit('snackbarError', 'Erro ao atualizar.')
        })
    },
    excluirContaPagar: ({commit, dispatch}, data) => {
        dispatch('setModalExcluirContaPagar', false)
        dispatch('setModalCadastroContaPagar', false)
        commit('setOverlay', true)
        ContaPagarService.excluir(data.id)
        .then(res => {
            commit('removeContaPagar', data)
            commit('setOverlay', false)
            commit('snackbarError', 'Registro excluído.')
        })
        .catch(e => {
            commit('snackbarError', 'Erro ao atualizar.')
        })
    },
    setModalCadastroContaPagar: ({commit}, status) => {
        commit('setModalCadastrarContaPagar', false)
        setTimeout(() => {
            commit('setModalCadastrarContaPagar', status)
        }, 100);
    },
    setModalBaixaContaPagar: ({commit}, status) => {
        commit('setModalBaixaContaPagar', false)
        setTimeout(() => {
            commit('setModalBaixaContaPagar', status)
        }, 100);
    },
    setModalExcluirContaPagar: ({commit}, status) => {
        commit('setModalExcluirContaPagar', false)
        setTimeout(() => {
            commit('setModalExcluirContaPagar', status)
        }, 100);
    },
}

export default {}